import {AxiosResponse} from "axios";
import $api from "../../../http";
import {Channel} from "../../../models/Channel";

export function channelInfo(channelId: string, shorts: boolean = false): Promise<AxiosResponse<Channel>> {
    return $api.get<Channel>(`channel/${channelId}?shorts=${shorts}`)
}